/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://6lb5xx4gmffbpprfyqv7jtp5ra.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-itvztjyacne2xeucsf7kfdclvq",
    "aws_cognito_identity_pool_id": "us-east-1:dd54cdff-974e-436f-ab6e-1428e0d8b901",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_uFJXH23iL",
    "aws_user_pools_web_client_id": "12ip3286hh8fftlmo0bdbjmftn",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "doubledoorinnd74d6fc3ad5f4085bbd0fb38c572d99089a79-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
